import parseHtml from "html-react-parser";
import constants from "src/constants";

const productionFooterTags = `
<script data-cfasync="false" type="text/javascript">
window.civchat = {
  apiKey: "${constants.Api.UserComApiKey}",
};
</script>
<script data-cfasync="false" type="text/javascript" src="https://vivido.user.com/widget.js"></script>`;

export default function Footers() {
  return (
    <>
      {process.env.NODE_ENV !== "development" &&
        parseHtml(productionFooterTags)}
    </>
  );
}
